// import './pop-up.scss'
import React, { useState, useEffect, useRef } from 'react'
import { toastr } from 'react-redux-toastr'

import Select from 'react-select'
import {
  isPossiblePhoneNumber,
  parsePhoneNumber,
} from 'react-phone-number-input'
import { connectAffiliate } from './Affiliate.connect'
import { countryOptions } from '../../helpers/countryList'
import { useSelector } from 'react-redux'

const AddUserModal = ({
  actions,
  onDidDismiss,
  width,
  setOpen,
  getAffUserCount,
}) => {
  const [mobile, setMobile] = useState(false)
  const [countryCode, setCountryCode] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const [message, setMessage] = useState('')
  const [isSending, setIsSending] = useState(false)
  const [mobileNumCounter, setMobileNumCounter] = useState(0)
  const [hideFirstPass, setHideFirstPass] = useState(false)
  const [hideSecondPass, setHideSecondPass] = useState(false)
  const [otpVerified, setOtpVerified] = useState(false)
  const [orderId, setOrderId] = useState('')
  const [selfPassword, setSelfPassword] = useState('')
  const [selfPasswordMessage, setSelfPasswordMessage] = useState('')

  const isMobile = useSelector((state) => state.promotions?.isMobile)

  const initialMinute = 0,
    initialSeconds = 59

  const [seconds, setSeconds] = useState(initialSeconds)

  const validateMobile = (e) => {
    const value = e?.target?.value
    setMobileNumCounter(value.length)
    if (value?.length <= selectedCountry?.length) {
      e.target.value = value?.replace(/[^\d]/g, '')
      setUsername(e.target.value)
    } else {
      e.target.value = username
    }
    if (value?.length === selectedCountry?.length) {
      setIsSendingNew(false)
      setIsSending(false)
      setSeconds(59)
      setSecondsNew(59)
    }
    setOtpVerified(false)
    setOrderId('')

    try {
      if (!mobile.length && value.length === 1 && !otp && !message) {
        const startSignUp = window.srtmCommands.push({
          event: 'track.user.registration',
          payload: { action: 'start' },
        })
      }
    } catch (e) {}

    if (!value) {
      setMessage('This field is required!')
      return
    } else if (value.length !== selectedCountry?.length) {
      setMessage(`Phone number must be ${selectedCountry?.length} digits`)
      setIsValid(false)
    } else if (isPossiblePhoneNumber(`+91${value}`)) {
      setIsValid(true)
      setMobile(value)
      const phoneNumber = parsePhoneNumber(`+91${value}`)
      if (phoneNumber) {
        const code = phoneNumber.countryCallingCode
        setCountryCode(code)
        setMessage('')
        setIsSendingNew(false)
        setOtpSent(false)
      }

      setMessage('')
    }
  }

  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  const [otpMessage, setOtpMessage] = useState('')
  const [isOtpValid, setIsOtpValid] = useState(false)
  const [password, setPassword] = useState(false)
  const [name, setName] = useState('')

  const [passwordMessage, setPasswordMessage] = useState('')
  const [nameMessage, setNameMessage] = useState('')

  const [confirmMessage, setConfirmMessage] = useState('')

  const ref_input = useRef()
  const [otp, setOtp] = useState()

  useEffect(() => {
    if ('OTPCredential' in window) {
      window.addEventListener('DOMContentLoaded', (e) => {
        const input = document.querySelector(
          'input[autocomplete="one-time-code"]'
        )
        if (!input) return

        navigator.credentials
          .get({
            otp: { transport: ['sms'] },
          })
          .then((otp) => {
            input.value = otp.code
          })
          .catch((err) => {
            console.log(err)
          })
      })
    }
  }, [])

  const validatePassword = (password) => {
    setIsSending(false)

    if (password.length < 5 || password.length > 16) {
      setPasswordMessage('Password must be 5-16 characters long')
      setPassword(password)
    } else {
      setPasswordMessage('')
      setConfirmMessage(true)
      setPassword(password)
    }
  }

  const validateName = (name) => {
    setIsSending(false)
    if (name.length < 3) {
      setNameMessage('Username should be minimus 3 characters')
    } else {
      setNameMessage('')
      setConfirmMessage(true)
      setName(name)
    }
  }

  const validatePasswordConfirm = (confirmPassword) => {
    setIsSending(false)

    if (confirmPassword !== password) {
      setConfirmMessage('Passwords do not match')
    } else if (password.length < 5 || password.length > 16) {
      setPasswordMessage('Password must be 5-16 characters long')
      setConfirmMessage('Password must be 5-16 characters long')
    } else {
      setConfirmMessage('')
      setPasswordMessage('')
    }
  }

  const validateSelfPassword = (value) => {
    setSelfPassword(value)
    if (value.length < 5) {
      setSelfPasswordMessage('Self Password must be at least 5 characters')
    } else {
      setSelfPasswordMessage('')
    }
  }

  const validateOtp = (otp) => {
    setIsSending(false)
    setOtpMessage('')
    setOtp(otp)
    if (otp.length != 6) {
      setIsOtpValid(false)
    } else {
      ref_input.current.focus()
      setIsOtpValid(true)
      setOtpMessage('')
    }
  }

  const resendOTP = async () => {
    const dataOTP = {
      orderId: orderId,
    }

    await actions
      .resendOTP(dataOTP)
      .then((res) => {
        if (res.status) {
          toastr.success('', `${res.data.msg}`)
          res?.data?.otp_expiry_time
            ? setSecondsNew(Number(res?.data?.otp_expiry_time))
            : setSeconds(59)
        }
      })
      .catch((e) => toastr.error('', `${e}`))
  }

  const [focus, setFocus] = useState(false)

  const onfocusInput = () => {
    setFocus(true)
  }
  const onBlurInput = () => {
    setFocus(false)
  }

  const [otpSent, setOtpSent] = useState(false)
  const [isSendingNew, setIsSendingNew] = useState(false)
  let [username, setUsername] = useState('')

  const mobileValidationNew = async (e) => {
    setIsSendingNew(true)

    if (!mobile.length) {
      setMessage('This field is required!')
      setIsSendingNew(false)
      return
    } else {
      const data = {
        country_code: selectedCountry.value,
        mobile: `${mobile}`,
      }

      console.log(data, 'mobilemobile')

      await actions
        .postNumberSignUp(data)
        .then((res) => {
          console.log(mobile, res, 'mobilemobile')
          if (res.status === 200) {
            console.log('res', res)
            toastr.success('', `${res?.data?.msg}`)
            setOtpSent(true)
            setOrderId(res?.data?.data?.orderId)
            res?.data?.otp_expiry_time &&
              setSecondsNew(Number(res?.data?.otp_expiry_time))
          }
        })
        .catch((e) => {
          setIsSendingNew(false)
          console.log('err', e)
          toastr.error('', `${e.msg}`)
        })
    }
  }

  const initialMinuteNew = 0,
    initialSecondsNew = 59
  const [minutesNew, setMinutesNew] = useState(initialMinuteNew)
  const [secondsNew, setSecondsNew] = useState(initialSecondsNew)

  useEffect(() => {
    if (otpSent) {
      let myIntervalNew = setInterval(() => {
        if (secondsNew > 0) {
          setSecondsNew(secondsNew - 1)
        }
        if (secondsNew === 0) {
          if (minutesNew === 0) {
            clearInterval(myIntervalNew)
          } else {
            setMinutesNew(minutesNew - 1)
            setSecondsNew(59)
          }
        }
      }, 1000)
      return () => {
        clearInterval(myIntervalNew)
      }
    }
  })

  const options = countryOptions.map((country) => ({
    value: country.value,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={`https://flagcdn.com/w20/${country.flag.toLowerCase()}.png`}
          alt={country.label}
          style={{ marginRight: 10 }}
        />
        {country.label}
      </div>
    ),
    country: country.country,
    length: country.length,
  }))
  const [selectedCountry, setSelectedCountry] = useState(
    options.find((option) => option.value === '+91')
  )

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption)
    setOtpVerified(false)
    setOrderId('')
  }

  const verifyOtp = async (e) => {
    if (!isMobile) return

    setIsSending(true)
    let erroredFields = false

    if (!mobile) {
      setMessage('This field is required!')
      setIsValid(false)
      setIsSending(false)
      erroredFields = true
    }

    if (mobile && !orderId) {
      setMessage('Please send Otp First!')
      setIsValid(false)
      setIsSending(false)
      erroredFields = true
    }

    if (!otp) {
      setOtpMessage('This field is required!')
      setIsValid(false)
      setIsSending(false)
      erroredFields = true
    }

    if (otp?.length && otp?.length !== 6) {
      setOtpMessage('OTP is invalid!')
      setIsValid(false)
      setIsSending(false)
      erroredFields = true
    }

    if (!erroredFields) {
      const dataForOTP = {
        orderId: orderId,
        otp: otp,
      }

      await actions
        .verifyOTP(dataForOTP)
        .then(async (res) => {
          if (res.status === 200) {
            res?.data?.status
              ? toastr.success('', res?.data?.msg)
              : toastr.error('', res?.data?.msg || res?.msg)

            if (res?.data?.status) {
              setOtpVerified(true)
            }
            setIsSending(false)
          }
        })
        .catch((e) => {
          setIsSending(false)
          toastr.error('', `${e?.data?.msg || e?.msg}`)
        })
    }
  }

  const modalRef = useRef(null)

  const onClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  const isFormValid = () => {
    let valid = true

    if (isMobile) {
      if (!mobile) {
        setMessage('Phone number is required')
        valid = false
      }
      if (!otpVerified) {
        setOtpMessage('Please verify OTP first')
        valid = false
      }
    }

    if (!name || name.length < 3) {
      setNameMessage('Username must be at least 3 characters')
      valid = false
    }

    if (!password || password.length < 5 || password.length > 16) {
      setPasswordMessage('Password must be 5-16 characters long')
      valid = false
    }

    if (confirmMessage) {
      valid = false
    }

    if (!selfPassword || selfPassword.length < 5) {
      setSelfPasswordMessage('Self Password must be at least 5 characters')
      valid = false
    }

    return valid
  }

  // UPDATED SUBMIT FUNCTION
  const onSubmit = async () => {
    if (!isFormValid()) {
      toastr.error('', 'Please fix the required fields')
      return
    }

    setIsSending(true)

    const data = {
      name: name,
      user_name: name,
      mobile: isMobile ? mobile : '',
      password: password,
      self_password: selfPassword,
    }

    if (!isMobile) delete data.mobile

    await actions
      .registerAffiliate(data)
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.status) {
            getAffUserCount()
            toastr.success('', res?.data?.msg)
            setIsSending(false)
            onDidDismiss(false)
            setOpen(false)
          } else {
            toastr.error('', res?.data?.msg || res?.msg)
            setIsSending(false)
          }
        }
      })
      .catch((e) => {
        setIsSending(false)
        toastr.error('', `${e?.data?.msg || e?.msg}`)
      })
  }

  return (
    <>
      <div className="loginPopUp">
        <div className={`pop-up_wrapper `} style={{ left: 0 }}>
          <div className="modal-overlay">
            <div ref={modalRef} className={`pop-up login-desktop`}>
              <div className="signUpNew_wrapper">
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    className="signUpNew_header__title"
                    style={{
                      marginTop: '12px',
                      marginBottom: '0px',
                    }}
                  >
                    ADD NEW USER
                  </div>
                  <div style={{ marginRight: '7px' }} onClick={onClose}>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="15.5" cy="15.5" r="15.5" fill="#142326" />
                      <path
                        d="M11.2045 10.0005C10.9659 10.0008 10.7328 10.0722 10.5349 10.2057C10.3371 10.3391 10.1835 10.5285 10.0938 10.7496C10.0042 10.9707 9.98244 11.2136 10.0314 11.4471C10.0804 11.6806 10.1979 11.8943 10.3689 12.0607L13.7205 15.4122L10.3689 18.7638C10.2538 18.8744 10.1618 19.0068 10.0985 19.1534C10.0351 19.2999 10.0017 19.4576 10.0001 19.6173C9.99844 19.7769 10.0287 19.9353 10.089 20.0831C10.1494 20.2309 10.2386 20.3652 10.3515 20.4781C10.4644 20.591 10.5987 20.6802 10.7465 20.7406C10.8943 20.8009 11.0527 20.8312 11.2123 20.8296C11.372 20.8279 11.5297 20.7945 11.6763 20.7311C11.8228 20.6678 11.9552 20.5758 12.0658 20.4607L15.4174 17.1091L18.7689 20.4607C18.8795 20.5758 19.012 20.6678 19.1585 20.7311C19.3051 20.7945 19.4628 20.8279 19.6224 20.8296C19.7821 20.8312 19.9405 20.801 20.0883 20.7406C20.2361 20.6803 20.3704 20.591 20.4833 20.4781C20.5962 20.3652 20.6854 20.2309 20.7457 20.0831C20.8061 19.9353 20.8363 19.7769 20.8347 19.6173C20.8331 19.4577 20.7996 19.2999 20.7363 19.1534C20.6729 19.0068 20.581 18.8744 20.4658 18.7638L17.1143 15.4122L20.4658 12.0607C20.6392 11.8921 20.7577 11.6751 20.8056 11.4381C20.8536 11.2011 20.8288 10.9551 20.7345 10.7324C20.6403 10.5097 20.481 10.3206 20.2774 10.19C20.0739 10.0595 19.8357 9.99339 19.5939 10.0005C19.2822 10.0098 18.9863 10.1401 18.7689 10.3638L15.4174 13.7154L12.0658 10.3638C11.9539 10.2487 11.8199 10.1573 11.672 10.0949C11.524 10.0325 11.3651 10.0004 11.2045 10.0005V10.0005Z"
                        fill="#fff"
                      />
                    </svg>
                  </div>
                </div>

                <div className="loginPopUpContainer forgot-step">
                  {isMobile && (
                    <>
                      <div
                        className="signUpNew_inputContainer"
                        style={{ marginBottom: '0' }}
                      >
                        <div className="signUpNew_inputContainer-input-wrapper__number">
                          <div className="signUpNew_inputContainer-input-wrapper__number__country">
                            <Select
                              options={options}
                              onChange={handleCountryChange}
                              placeholder="Select a country"
                              defaultValue={options.find(
                                (option) => option.value === '+91'
                              )}
                              isSearchable={true}
                              filterOption={(option, inputValue) =>
                                option.data?.country
                                  ?.toLowerCase()
                                  .includes(inputValue.toLowerCase()) ||
                                option.data?.value
                                  ?.toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              }
                              styles={{
                                option: (provided) => ({
                                  ...provided,
                                  display: 'flex',
                                  alignItems: 'center',
                                  width: '150px!important',
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  display: 'flex',
                                  alignItems: 'center',
                                }),
                              }}
                            />
                          </div>
                          <input
                            className="signUpNew_inputContainer-input phone-counrty"
                            onFocus={onfocusInput}
                            onBlur={onBlurInput}
                            formcontrolname="username"
                            placeholder=" Whatsapp Number"
                            name="number"
                            type="number"
                            onInput={(e) =>
                              (e.target.value = e.target.value.slice(
                                0,
                                selectedCountry?.length
                              ))
                            }
                            autoComplete="username"
                            onIonChange={validateMobile}
                            onChange={validateMobile}
                            value={`${username?.replace(' ', '')}`}
                          />
                        </div>
                        <div className="signUpNew_inputContainer_row">
                          <div className="signUpNew_inputContainer_row-error"></div>
                          <span
                            className={`signUpNew_inputContainer_row-counter ${
                              mobileNumCounter === selectedCountry?.length &&
                              'counterDone'
                            }`}
                          >
                            {mobileNumCounter}/{selectedCountry?.length}
                          </span>
                        </div>
                        {isMobile && (
                          <div className="signUpNew_inputContainer_otp">
                            <div
                              className={`signUpNew_inputContainer_otp-button ${
                                otpSent ||
                                mobileNumCounter !== selectedCountry?.length
                                  ? 'otpButtonDisabled'
                                  : ''
                              }`}
                              onClick={() => mobileValidationNew()}
                            >
                              Get OTP
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="signUpNew_inputContainer">
                        <input
                          className="signUpNew_inputContainer-input otp"
                          formcontrolname="otp"
                          placeholder="OTP"
                          name="otp"
                          type="number"
                          pattern="\d*"
                          autoComplete="one-time-code"
                          onInput={(e) =>
                            (e.target.value = e.target.value
                              .replace(/[^0-9]/g, '')
                              .slice(0, 6))
                          }
                          required
                          maxLength={6}
                          onChange={(e) => validateOtp(e.target.value)}
                        />
                        <div className="otp-container">
                          <div
                            className={`signUpMessageError ${
                              otpMessage ? 'otpMessage' : ''
                            }`}
                          >
                            {otpMessage}
                          </div>

                          {isSendingNew && !otpVerified && (
                            <div className="signUpNew_inputContainer-resendOTP">
                              <div
                                style={
                                  secondsNew === 0
                                    ? {
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                      }
                                    : null
                                }
                                onClick={() =>
                                  secondsNew === 0 ? setSecondsNew(59) : null
                                }
                              >
                                <span
                                  className="signUpNew_inputContainer-resendOTP"
                                  onClick={secondsNew === 0 ? resendOTP : null}
                                >
                                  Resend OTP
                                </span>
                                {minutesNew === 0 && secondsNew === 0 ? null : (
                                  <span>
                                    {' '}
                                    in {minutesNew}:
                                    {secondsNew < 10
                                      ? `0${secondsNew}`
                                      : secondsNew}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="signUpNew_inputContainer_otp">
                          <div
                            className={`signUpNew_inputContainer_otp-button ${
                              otpSent && otp?.length === 6 && !otpVerified
                                ? ''
                                : 'otpButtonDisabled topPosition'
                            }`}
                            onClick={() =>
                              otpSent && otp?.length === 6 && !otpVerified
                                ? verifyOtp()
                                : null
                            }
                          >
                            Verify OTP
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="signUpNew_inputContainer phone">
                    <input
                      required
                      ref={ref_input}
                      formcontrolname="122"
                      placeholder="Enter username"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 16))
                      }
                      name="username"
                      className="signUpNew_inputContainer-input phone"
                      autoComplete="off"
                      onKeyDown={onKeyDown}
                      onChange={(e) => validateName(e.target.value)}
                      onFocus={() => null}
                    />
                    <div className="signUpNew_inputContainer_row">
                      <div className="signUpNew_inputContainer_row-error">
                        {nameMessage}
                      </div>
                    </div>
                  </div>

                  <div className="signUpNew_inputContainer lock">
                    <input
                      required
                      placeholder="Password"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 16))
                      }
                      className={
                        hideFirstPass
                          ? 'signUpNew_inputContainer-input signup-password'
                          : 'signUpNew_inputContainer-input passwordDots'
                      }
                      autoComplete="off"
                      onKeyDown={onKeyDown}
                      onChange={(e) => validatePassword(e.target.value)}
                    />
                    <div
                      className={`${
                        hideFirstPass
                          ? 'signUpNew_icons eyeOff'
                          : 'signUpNew_icons eye'
                      } `}
                      onClick={() => setHideFirstPass(!hideFirstPass)}
                    />

                    <div className="signUpNew_inputContainer_row">
                      <div className="signUpNew_inputContainer_row-error">
                        {passwordMessage}
                      </div>
                    </div>
                  </div>

                  <div className="signUpNew_inputContainer lock">
                    <input
                      placeholder="Confirm Password"
                      className={
                        hideSecondPass
                          ? 'signUpNew_inputContainer-input signup-password'
                          : 'signUpNew_inputContainer-input passwordDots'
                      }
                      autoComplete="off"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 16))
                      }
                      onKeyDown={onKeyDown}
                      onChange={(e) => validatePasswordConfirm(e.target.value)}
                    />
                    <div
                      className={`${
                        hideSecondPass
                          ? 'signUpNew_icons eyeOff'
                          : 'signUpNew_icons eye'
                      } `}
                      onClick={() => setHideSecondPass(!hideSecondPass)}
                    />

                    <div className="signUpNew_inputContainer_row">
                      <div className="signUpNew_inputContainer_row-error">
                        {confirmMessage}
                      </div>
                    </div>
                  </div>

                  <div className="signUpNew_inputContainer lock">
                    <input
                      placeholder="Self Password"
                      className={
                        hideSecondPass
                          ? 'signUpNew_inputContainer-input signup-password'
                          : 'signUpNew_inputContainer-input passwordDots'
                      }
                      autoComplete="off"
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 16))
                      }
                      onKeyDown={onKeyDown}
                      onChange={(e) => validateSelfPassword(e.target.value)}
                    />
                    <div
                      className={`${
                        hideSecondPass
                          ? 'signUpNew_icons eyeOff'
                          : 'signUpNew_icons eye'
                      } `}
                      onClick={() => setHideSecondPass(!hideSecondPass)}
                    />

                    <div className="signUpNew_inputContainer_row">
                      <div className="signUpNew_inputContainer_row-error">
                        {selfPasswordMessage}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pop-up-content__buttons-first">
                  <button
                    onClick={onSubmit}
                    style={
                      isSending && width < 1024
                        ? { background: '#c0bdbd' }
                        : { marginBottom: '10px' }
                    }
                    className={`pop-up-content__buttons-first__btn`}
                  >
                    <span className="shadow"></span>
                    <span className="edge "></span>
                    <span className="front refreshBtn login">Register</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default connectAffiliate()(AddUserModal)
